<template>
  <div>
    <div class="flex margin-right-40">
      <!-- 电池仓 -->
      <!-- 电池信息--表格 -->
      <LeftSiteInformation :userList="siteInfoList" :bigtitle="siteInfoTitle"/>
      
    </div>
    <div class="flex">
      
      <!-- 累计里程 -->
      <AccumulatedMileage :peratingMileage='peratingMileage' class="flex1 margin-top"/>
      <!-- 月换电次数 -->
      <ChangeBatteryCount class="flex1"/>
    </div>
    <div>
      <!-- 单个站点--考核指标 -->
      <taskIndicators class="taskIndicators"/>  
      <div class="flex">
        <!-- 成本变化趋势 -->
        <CostTrend class="flex1"/>
        <!-- 收入数据趋势 -->
        <IncomeTrend class="flex1"/>
        <!-- 利润收入趋势 -->
        <ProfitTrend class="flex1"/>
      </div>
      <!-- 性能分析 -->
      <BigTitle :bigtitle="performanceTitle"></BigTitle>
      <div class="flex">
        <!-- 电池健康测评度 -->
        <BatteryHealth class="flex1"/>
        <!-- 电池衰减度测评 -->
        <BatteryAttenuation class="flex1"/>
      </div>
      <div class="flex">
        <!-- 电压电流温度监测 -->
        <Temperature class="flex1"/>
        <!-- 度电里程变化趋势 -->
        <MileageChangeTrend class="flex1"/>
      </div>
    </div>
  </div>
</template>

<script>
import BigTitle from '../bigTitle';
//电池信息
import LeftSiteInformation from "@/views/singleSite/leftSiteInformation";
// 累计里程
import AccumulatedMileage from "@/components/echart/batteryHolderCharts/accumulatedMileage.vue";
// 月换电次数
import ChangeBatteryCount from "@/components/echart/batteryHolderCharts/changeBatteryCount";
//成本分析
import taskIndicators from "@/views/batteryHolder/evaluationIndex";
// 成本趋势
import CostTrend from "@/components/echart/batteryHolderCharts/costTrend.vue";
//收入数据趋势
import IncomeTrend from "@/components/echart/batteryHolderCharts/incomeTrend.vue";
//运营成本
import ProfitTrend from "@/components/echart/batteryHolderCharts/profitTrend";

//电池健康
import BatteryHealth from "@/components/echart/batteryHolderCharts/batteryHealth";
//电池衰减
import BatteryAttenuation from "@/components/echart/batteryHolderCharts/batteryAttenuation";
//温度趋势
import Temperature from "@/components/echart/batteryHolderCharts/temperature";
// 里程变化趋势
import MileageChangeTrend from "@/components/echart/batteryHolderCharts/mileageChangeTrend";



import { batteryHolderLeft } from '@/api/batteryHolder/left';
import { changeToVoidString,formatTime } from '@/utils/index';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      options: {},
      // 站点信息
      //标题
      siteInfoTitle:{
        CHN:'电池信息',
        ENG:'Battery information'
      },
      performanceTitle:{
        CHN:'性能分析',
        ENG:'Performance analysis'
      },
      //展示数据
      peratingMileage:100,//里程
      siteInfoList:[{
        key:'电池编码',
        value:""
      },{
        key:'生产商',
        value:""
      },{
        key:'电池类型',
        value:""
      },{
        key:'串联总数',
        value:""
      },{
        key:'硬件版本号',
        value:""
      },{
        key:'软件版本号',
        value:""
      },{
        key:'交付日期',
        value:""
      },{
        key:'质保年限',
        value:""
      },{
        key:'单体额定电压',
        value:""
      },{
        key:'放电截止电压',
        value:""
      },{
        key:'累计运行里程',
        value:""
      },{
        key:'记录时间',
        value:""
      }],
      //车辆指标
      //标题
      carIndicatorsTitle:{
        CHN:'车辆指标',
        ENG:'Car indicators'
      },
    };
  },
  components: {
    BigTitle,
    LeftSiteInformation,
    AccumulatedMileage,
    ChangeBatteryCount,
    taskIndicators,
    CostTrend,
    IncomeTrend,
    ProfitTrend,
    BatteryHealth,
    BatteryAttenuation,
    Temperature,
    MileageChangeTrend
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    
  },
  mounted () {
  },
  methods: {
    // 刷新接口需要每个子组件封装一个getData();
    getData(data){
      this.selectBatteryDetail(data);
    },
    selectBatteryDetail(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-congdiancang-dianchixinxi',
          '@battery_id':data.batteryId,
        })
        .then((res) => {
          if(!res) return;
          res = res[0];
          _this.peratingMileage = res.peratingMileage||0;
          console.log("电池信息",res)
          _this.siteInfoList = [{
        key:'电池编码',
        value:changeToVoidString(res.batteryNumber)
      },{
        key:'生产商',
        value:changeToVoidString(res.manufacturerName)
      },{
        key:'电池类型',
        value:res.batteryType||""
      },{
        key:'串联总数',
        value:res.totalTandem||""
      },{
        key:'硬件版本号',
        value:res.hardwareVersion||""
      },{
        key:'软件版本号',
        value:res.softwareVersion||""
      },{
        key:'交付日期',
        value:res.deliveryDate?res.deliveryDate.split(" ")[0]:''
      },{
        key:'质保年限',
        value:res.warrantyPeriod||""
      },{
        key:'单体额定电压',
        value:res.ratedVoltageSingleUnit||""
      },{
        key:'放电截止电压',
        value:res.discharge_cut_off_voltage||""
      },{
        key:'累计运行里程',
        value:res.perating_mileage
      },{
        key:'记录时间',
        value:res.createTime
          }]
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}
.taskIndicators{
  width:1550px;
}
</style>